import { defineComponent as _defineComponent } from 'vue'
interface Props {
  value?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UiSpinner',
  props: {
    value: { type: Boolean }
  },
  setup(__props: any) {

const delays: Record<any, any> = {
  1: 'animation-delay-0',
  2: 'animation-delay-[200ms]',
  3: 'animation-delay-[400ms]',
  4: 'animation-delay-[600ms]',
};



return { __sfc: true,delays }
}

})